// One-shot confirmation messages across auth-gate transitions (UX-81): the
// password-change and 2FA-enrollment gates swap the whole view on success, so
// the acknowledgment ("Password updated.") must survive the swap. Stored in
// sessionStorage, read once, then cleared.
const KEY = "sgnic-flash";

export function setFlash(text) {
  try { sessionStorage.setItem(KEY, text); } catch { /* storage unavailable — drop the nicety */ }
}

export function takeFlash() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) sessionStorage.removeItem(KEY);
    return v || null;
  } catch { return null; }
}
